import PropTypes from 'prop-types'
import React, { Component } from 'react'

import Icon from 'components/Icon'
import LinkInlineArrowShort from 'components/LinkInlineArrowShort'
import Modal from 'components/Modal'
import ToggleHorizontal from 'components/ToggleHorizontal'
import ToggleVertical from 'components/ToggleVertical'
import TooltipButton from 'components/TooltipButton'
import { MenuMainConsumer } from 'contexts/MenuMain'
import { TextLH, TextSmallDescr } from 'styles/components/typography'

import SubscriptionInfo from './components/SubscriptionInfo'
import { Wrapper, TextBox, InfoButton, ButtonBlock } from './styles'

class SubscriptionToggler extends Component {
  constructor(props) {
    super(props)

    this.modalRef = React.createRef()

    this.state = {
      modalOpened: false,
      prevIsMobile: props.mobile,
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { mobile, breakpoint } = nextProps
    const { prevIsMobile } = prevState

    if (breakpoint && mobile !== prevIsMobile) {
      return {
        prevIsMobile: mobile,
        modalOpened: false,
      }
    }

    return null
  }

  handleModalOpen = () => {
    this.setState({
      modalOpened: true,
    })
  }

  closeModal = () => {
    this.setState({
      modalOpened: false,
    })
  }

  renderMobile = () => {
    const {
      toggleSubscription,
      productType,
      productInfo,
      dict,
      isDisabled,
    } = this.props
    const { modalOpened } = this.state

    return (
      <div className="row justify-content-center">
        <div className="col-6">
          <div className="d-inline-block position-relative">
            <TextLH
              dangerouslySetInnerHTML={{
                __html: dict.kits[productType].types.subscription.title,
              }}
            />
            <InfoButton
              className="link--inverted"
              onClick={this.handleModalOpen}
            >
              <Icon id="btn_question" color="black" />
            </InfoButton>
          </div>
        </div>
        <ButtonBlock className="col-6 ">
          <ToggleHorizontal
            {...{
              isDisabled,
            }}
            toggleCb={type =>
              toggleSubscription &&
              toggleSubscription({
                isSubscription: type === 'subscription',
                productType,
              })
            }
            initial={productInfo.isSubscription}
          />
        </ButtonBlock>
        <Modal
          modalRef={this.modalRef}
          modalOpen={modalOpened}
          handleCloseModal={this.closeModal}
          isMobile={true}
        >
          <SubscriptionInfo
            whiteTheme={true}
            texts={dict.kits[productType].types.subscription}
          />
        </Modal>
      </div>
    )
  }

  renderTablet = ({ isTablet }) => {
    const {
      toggleSubscription,
      productType,
      productInfo,
      dict,
      isDisabled,
    } = this.props

    return (
      <ToggleVertical
        {...{
          isDisabled,
          initial: productInfo.isSubscription,
        }}
        toggleCb={type =>
          toggleSubscription &&
          toggleSubscription({
            isSubscription: type === 'subscription',
            productType,
          })
        }
        labelTrue={dict.togglers.subscription.true_label}
        labelFalse={dict.togglers.subscription.false_label}
        trueValueSubContent={
          <TextBox>
            <MenuMainConsumer>
              {({ menuNode }) => (
                <TooltipButton
                  isMobile={false}
                  position={isTablet ? 'bottom' : 'right'}
                  topIndentNode={menuNode}
                  close={{
                    click: !isTablet,
                    scroll: false,
                    resize: true,
                    cross: isTablet,
                  }}
                  deltaArrow={{
                    y: isTablet ? 0 : 2,
                  }}
                  content={
                    <SubscriptionInfo
                      texts={dict.kits[productType].types.subscription}
                    />
                  }
                >
                  <LinkInlineArrowShort as="span" className="link--inverted">
                    <TextSmallDescr
                      className="text-nowrap"
                      dangerouslySetInnerHTML={{
                        __html: dict.kits[productType].types.subscription.info,
                      }}
                    />
                  </LinkInlineArrowShort>
                </TooltipButton>
              )}
            </MenuMainConsumer>
          </TextBox>
        }
      />
    )
  }

  render() {
    const { breakpoint, mobile, tablet } = this.props

    if (!breakpoint) {
      return null
    }

    return (
      <Wrapper>
        {mobile ? this.renderMobile() : this.renderTablet({ isTablet: tablet })}
      </Wrapper>
    )
  }
}

SubscriptionToggler.propTypes = {
  dict: PropTypes.object.isRequired,
  productInfo: PropTypes.object.isRequired,
  productType: PropTypes.string.isRequired,
  toggleSubscription: PropTypes.func.isRequired,
  breakpoint: PropTypes.string,
  mobile: PropTypes.bool,
  tablet: PropTypes.bool,
  isDisabled: PropTypes.bool.isRequired,
}

SubscriptionToggler.defaultProps = {
  isDisabled: false,
}

export default SubscriptionToggler
